var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',_vm._g(_vm._b({attrs:{"loading":_vm.loading,"label":_vm.label},on:{"click":_vm.sendEmailVerification}},'base-button',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }